function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.056 15.278L2.5 9.936 4.056 8.44l4 3.846 8.444-8.12 1.556 1.496-10 9.616z",
  fill: "#fff"
});

var SvgIconCheckboxChecked = function SvgIconCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjA1NTU2IDE1LjI3NzZMMi41IDkuOTM1NzNMNC4wNTU1NiA4LjQ0MDAxTDguMDU1NTYgMTIuMjg2MkwxNi41IDQuMTY2NUwxOC4wNTU2IDUuNjYyMjNMOC4wNTU1NiAxNS4yNzc2VjE1LjI3NzZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconCheckboxChecked as ReactComponent };